/** Clockwise seat iteration helpers shared by session games. */
export function nextSeatWhere<T>(seats: readonly (T | null)[], from: number, pred: (p: T, seat: number) => boolean): number | null {
  const n = seats.length;
  for (let d = 1; d <= n; d++) {
    const s = (from + d) % n;
    const p = seats[s];
    if (p && pred(p, s)) return s;
  }
  return null;
}

export function prevSeatWhere<T>(seats: readonly (T | null)[], from: number, pred: (p: T, seat: number) => boolean): number | null {
  const n = seats.length;
  for (let d = 1; d <= n; d++) {
    const s = (from - d + n * 2) % n;
    const p = seats[s];
    if (p && pred(p, s)) return s;
  }
  return null;
}

export function seatsWhere<T>(seats: readonly (T | null)[], pred: (p: T, seat: number) => boolean): number[] {
  const out: number[] = [];
  seats.forEach((p, s) => {
    if (p && pred(p, s)) out.push(s);
  });
  return out;
}

/** Splits `amount` among winners; odd chips go to the earliest winners in the given order. */
export function splitAmount(amount: number, winners: readonly number[]): Map<number, number> {
  const out = new Map<number, number>();
  if (winners.length === 0) return out;
  const share = Math.floor(amount / winners.length);
  let rem = amount - share * winners.length;
  for (const w of winners) {
    out.set(w, (out.get(w) ?? 0) + share + (rem > 0 ? 1 : 0));
    if (rem > 0) rem--;
  }
  return out;
}
